export default __webpack_public_path__ + "static/media/btn_right_arrow.a97966b2.svg";